import React, { Component } from 'react';
import GDDueDateCell from 'Components/GDTable/GDDueDateCell/GDDueDateCell';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell';
import GDMerchantNumberCell from 'Components/GDTable/GDMerchantNumberCell/GDMerchantNumberCell.jsx';
import InformationBubble from 'Components/information-bubble/InformationBubble.jsx';
import GDCurrencyCodeCell from 'Components/GDTable/GDCurrencyCodeCell/GDCurrencyCodeCell.jsx';
import GDDateCell from 'Components/GDTable/GDDateCell/GDDateCell.jsx';
import CardType from 'Components/CardType';
import Badge from 'Components/Badge/Badge.jsx';
import './AgGridComponentWrapper.scss';

import { customFormatclass, customClassCurrency, customClassTabular } from 'Components/GDTable/GDCustomFormat/GDCustomFormat';

export class AgGridComponentWrapper extends Component {
    constructor(props) {
        super(props);
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    render() {
        if (!this.props.value || this.props.value === '') {
            if (this.props.colDef.groupId === 'CURRENCY') {
                return <div key={this.props.node.rowIndex} className="gd-currency-code-cell gd-currency-code-cell__value" style={{ display: 'inline-flex' , marginTop: '12px'}}>--</div>
            } else {
                return (
                    <div key={this.props.node.rowIndex} className="gd-table__container-cell" style={{ display: 'inline-flex' , marginTop: '12px'}}>
                        --
              </div>
                );
            }
        }
        else if (this.props.colDef.groupId === 'INDICATOR') {
            return (
                <div key={this.props.node.rowIndex} className={'gd-table__container-cell'} style={{ display: 'inline-flex' }}>
                    {!(this.props.colDef.field === 'posEntryMode') ? (this.props.value === '1' ? 'Y' : (this.props.value === '9')?' ': 'N') : this.props.value}
                </div>
            );
        }
        else if (this.props.colDef.groupId === "DUEDATE")
            return (
                this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && <span className="due-date-view" style={{ display: 'inline-flex' }}>
                    <GDDueDateCell
                        dueDate={this.props.value}
                        dueDateDescription={this.props.data.daysRemaining === undefined ? 'daysRemaining' : this.props.data.daysRemaining}
                        dateFormat={this.props.context.componentParent.props.dateFormat}
                        isMerchantPortal={this.props.context.componentParent.props.isMerchantPortal}
                    />
                </span>
            );
        else if (this.props.colDef.groupId === "ACCOUNTNUMBER") {
            return (
                this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && <span>
                    <GDAccountNumberCell
                        id={JSON.stringify(this.props.node.rowIndex)}
                        accountNumber={this.props.value}
                        token={this.props.data.globalToken === undefined ? 'globalToken' : this.props.data.globalToken}
                        isMerchantPortal={this.props.context.componentParent.props.isMerchantPortal}
                        accountNumberStyle={{ fontSize: '14px', padding: '8px 0px' }}
                    />
                </span>
            );
        }
        else if (this.props.colDef.groupId === 'MERCHANTNUMBER') {
            const merchantNumber = this.props.data.merchantNumber === undefined ? 'merchantNumber' : this.props.data.merchantNumber;
            return (
                <GDMerchantNumberCell
                    merchantName={this.props.value}
                    merchantNumber={merchantNumber == null ? '' : merchantNumber}
                />
            );
        }
        else
            if (this.props.colDef.field === 'merchant_number') {
                return (
                    <GDColorCodedCell
                        key={this.props.node.rowIndex}
                        content={this.props.value}
                    />
                );
            }
            else if (this.props.colDef.groupId == 'RC' && this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props) {
                return (<div className={`gd-table__container-cell ${this.props.context.componentParent.props.isMerchantPortal ? 'click' : ''}`}
                    onClick={() => this.props.context.componentParent.props.isMerchantPortal ? this.props.context.componentParent.props.rowActionClick(this.props.node.rowIndex, 'RCA') : () => { }}
                    style={{ display: 'inline-flex' }}
                >
                    {this.props.value}
                    <span className="reason-code-tooltip">
                        <InformationBubble
                            id={`${this.props.value}_${this.props.node.rowIndex}`}
                            info
                            tooltipContent={this.props.data.reasonDescription === undefined ? this.props.data.codeDescription : this.props.data.reasonDescription}
                            place={'right'}
                        />
                    </span>
                </div>

                );
            }
            else if (this.props.colDef.groupId === 'DATE') {
                return (
                    this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && <GDDateCell
                        key={this.props.node.rowIndex}
                        date={this.props.value}
                        dateFormat={this.props.context.componentParent.props.dateFormat}
                        timeFormat={this.props.context.componentParent.props.timeFormat}
                        isMerchantPortal={this.props.context.componentParent.props.isMerchantPortal}
                    />
                );
            }
            else if (this.props.colDef.field === 'card_type' || this.props.colDef.groupId === 'CC_BADGE') {
                return (
                    <div key={this.props.node.rowIndex} className="gd-table__container-cell" style={{ display: 'inline-flex' }}>
                        <CardType
                            isUnmatchedQueue={this.props.isGridCompact}
                            abbreviation={this.props.value.toUpperCase()}
                            type={this.props.value.toUpperCase()}
                        />
                    </div>
                );
            }
            else if (this.props.colDef.groupId === 'BADGE') {
                const normalizedValue = this.props.value;
                const badgeType = this.props.context.componentParent.props.isMerchantPortal ? this.props.data.merchantStatusId : this.props.value;
                return (
                    <div key={this.props.node.rowIndex} className="bagde-cell-view" style={{ display: 'inline-flex' }}>
                        <Badge
                            badgeType={badgeType}
                            square={false}
                            isMerchantPortal={this.props.context.componentParent.props.isMerchantPortal}
                        >
                            {normalizedValue}
                        </Badge>
                    </div>
                );
            }
            else if (this.props.colDef.groupId === 'CURRENCY' || this.props.colDef.groupId === 'NEGATIVE_NUMBER') {
                const normalizedValue = this.props.value || '--';
                let normalizedUnits = '';
                let valueClass;
                if (this.props.colDef.field === "disputeAmount" && this.props.data.disputeCurrencyCode !== undefined) {
                    normalizedUnits = this.props.data.disputeCurrencyCode || '';
                }
                else if (this.props.colDef.field === "tranAmount" && this.props.data.tranCurrencyCode !== undefined) {
                    normalizedUnits = this.props.data.tranCurrencyCode || '';
                }else if ((this.props.colDef.field === "tranAmount" || this.props.colDef.field === "transactionAmount") && this.props.data.transactionCurrency !== undefined) {
                    normalizedUnits = this.props.data.transactionCurrency || '';
                }
                else if (this.props.colDef.isNewQueueLanding && this.props.colDef.field === "transactionAmount" && this.props.data.transactionCurrency !== undefined) {
                    normalizedUnits = this.props.data.transactionCurrency || '';
                }
                else
                    normalizedUnits = this.props.data.currencyCode || '';

                normalizedUnits = this.props.context.componentParent.props.isTransactionFlag ? '':normalizedUnits;
                if (Number.isNaN(Number.parseFloat(this.props.value))) {
                    return <GDCurrencyCodeCell
                        value={normalizedValue}
                        units={normalizedUnits}
                        customClass={valueClass}
                        headerClass={'agGrid-Amt'}
                        currencyClass ={'agGrid-CurrencyCss'}
                    />
                }

                if (!Number.isNaN(Number.parseFloat(normalizedValue)) && Number.parseFloat(normalizedValue) < 0) { valueClass = customFormatclass(customClassCurrency, this.props.colDef.groupId); }
                return (
                    <GDCurrencyCodeCell
                        value={normalizedValue}
                        units={normalizedUnits}
                        customClass={valueClass}
                        headerClass={'agGrid-Amt'}
                        currencyClass ={'agGrid-CurrencyCss'}
                    />
                );
            }

            else {
                let valueClass;
                let value = this.props.value;
                if (!Number.isNaN(Number.parseFloat(this.props.value)) && Number.parseFloat(this.props.value) < 0) {
                    valueClass = customFormatclass(customClassTabular, 'OTHER');
                    value *= (-1);
                }
                return (
                    <div className={valueClass ? 'gd-table__container-cell content-wrap' : 'gd-table__container-cell'}>
                        {value}
                    </div>
                );
            }
    }

    invokeParentMethod(keySeqKey) {

    };
}
export default AgGridComponentWrapper;